import { ErrorMessage, Field, Form, Formik, FormikProps } from "formik";
import { useEffect, useRef } from "react";
import * as Yup from "yup";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { ModalCustom } from "../../../../components/custom/modal-custom";

import { showToast } from "../../../../components/custom/custom-toast";
import { SelectOneDropdown } from "../../../../components/custom/select-one-dropdown";
import { dataAppType } from "../../../../constants/status";
import { useFetchData } from "../../../../hooks/useFetch";
import { API_APP_VERSION_ROUTER } from "../../../../services/api-config";
import { isSuccess } from "../../../../services/base-response";

interface AppVersionCreateProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setRefresh: (value: boolean) => void;
}

export const AppVersionCreate = ({ isOpen, setIsOpen, setRefresh }: AppVersionCreateProps) => {
  const formikRef = useRef<FormikProps<any> | null>(null);

  const { request: fetchDataCreate, baseResponse: responsesCreate } = useFetchData.Post();

  useEffect(() => {
    if (!isOpen) formikRef.current?.resetForm();
  }, [isOpen]);

  const handleSubmit = (values: any) => {
    const selectIdArray = values.selectId.split(",");
    const app_type = parseInt(selectIdArray[0], 10);
    const platform = parseInt(selectIdArray[1], 10);

    fetchDataCreate({
      endPoint: API_APP_VERSION_ROUTER.API_CREATE_APP_VERSION(),
      data: {
        app_type: app_type,
        platform: platform,
        version: values.version,
        is_force_update: values.is_force_update === true ? 1 : 0,
      },
    });
  };

  useEffect(() => {
    if (!responsesCreate) return;
    if (isSuccess(responsesCreate)) {
      showToast({ message: "Thêm mới thành công", type: "success" });
      setRefresh(true);
      setIsOpen(false);
    } else {
      showToast({ message: responsesCreate.message, type: "error" });
    }
  }, [responsesCreate]);

  const SubmittedForm = Yup.object().shape({
    version: Yup.string().required("Vui lòng nhập version"),
    selectId: Yup.string().min(1, "Ít nhất 1 phiên bản ").required("Vui lòng chọn phiên bản"),
  });

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        selectId: "",
        version: "",
        is_force_update: 0,
      }}
      validationSchema={SubmittedForm}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({ values, submitForm, resetForm, setFieldValue }) => {
        const bodyModal = () => {
          return (
            <Form className="">
              <div className="flex flex-wrap items-start gap-4">
                <div className="w-full bg-white p-4 pt-0 rounded-md">
                  <div className="flex flex-col gap-3">
                    <div>
                      <label htmlFor="version">
                        Phiên bản <span className="text-red-500">*</span>
                      </label>
                      <Field
                        value={values.version}
                        name="version"
                        type="text"
                        placeholder="Nhập thông tin"
                        className="form-input"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const inputValue = e.target.value;
                          setFieldValue("version", inputValue);
                        }}
                      />
                      <ErrorMessage name="version" component="div" className="text-red-500 text-xs mt-1" />
                    </div>
                  </div>

                  <div className="mt-3">
                    <label htmlFor="selectId">Ứng dụng</label>
                    <Field name="selectId">
                      {() => (
                        <SelectOneDropdown
                          selectdId={values.selectId}
                          placeholder="Chọn ứng dụng"
                          dataOptions={dataAppType}
                          getOptionLabel={(option) => option.name}
                          getOptionKey={(option) => option.id}
                          onChange={(selectedOption) => {
                            setFieldValue("selectId", selectedOption ? selectedOption.id : "");
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage name="selectId" component="div" className="text-red-500 text-xs mt-1" />
                  </div>
                  <div className="flex justify-start items-center mt-7">
                    <Field
                      type="checkbox"
                      name="is_force_update"
                      className="form-checkbox"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setFieldValue("is_force_update", e.target.checked);
                      }}
                    />
                    <span className="ml-2">Yêu cầu cập nhật</span>
                  </div>
                </div>
              </div>
            </Form>
          );
        };

        const footerModal = () => (
          <>
            <ButtonCustom
              type="button"
              text="Hủy"
              onClick={() => {
                resetForm();
                setIsOpen(false);
              }}
              className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
            />
            <ButtonCustom type="button" text="Lưu" onClick={submitForm} />
          </>
        );

        return (
          <ModalCustom
            data-testid="modal-custom"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            titleModal="Thêm mới phiên bản"
            bodyModal={bodyModal()}
            footerModal={footerModal()}
            modalSize="40%"
          />
        );
      }}
    </Formik>
  );
};
